import MallSelectStudent from '../module/mall/MallSelectStudent';
import CourseMall from '../module/mall/CourseMall';
import CommodityDetail from '../module/mall/CommodityDetail';
import OrderDetail from '../module/mall/OrderDetail';
import OrderConfirm from '../module/mall/OrderConfirm';
import MallShare from '../module/mall/MallShare';
import OnlineSchool from '../module/mall/School';
import OnlineSelectStudent from '../module/mall/SelectStudent';
import OnlineProductList from '../module/mall/ProductList';
import OnlineProductDetail from '../module/mall/ProductDetail';
import OnlineOrderConfirm from '../module/mall/OrderConfirmV5';
import OnlineOrderDetail from '../module/mall/OrderDetailV5';
import OnlineAddStudent from '../module/mall/AddStudent';
import OnlineRelevance from '../module/mall/Relevance';
import OnlinePaySuccess from '../module/mall/PaySuccess';
import OnlineRecommend from '../module/mall/Recommend';
import OnlineSearch from '../module/mall/ProductSearch';

export default {
  routes: [
    {
      path: '/mall/buyer',
      name: 'mall_select_student',
      component: MallSelectStudent,
      meta: {
        title: '选择学员',
        keepAlive: false,
        logined: true,
        notBrowser: false, // 是否拦截在浏览器打开
      },
    },
    {
      path: '/course/mall',
      name: 'course_mall',
      component: CourseMall,
      meta: {
        title: '购课商城',
        keepAlive: false,
        logined: true,
        notBrowser: false,
      },
    },
    {
      path: '/commodity/detail',
      name: 'commodity_detail',
      component: CommodityDetail,
      meta: {
        title: '商品详情',
        keepAlive: false,
        logined: true,
        notBrowser: false,
      },
    },
    {
      path: '/order/detail',
      name: 'order_detail',
      component: OrderDetail,
      meta: {
        title: '订单详情',
        keepAlive: false,
        logined: true,
        notBrowser: false,
      },
    },
    {
      path: '/order/confirm',
      name: 'order_confirm',
      component: OrderConfirm,
      meta: {
        title: '确认订单',
        keepAlive: false,
        logined: true,
        notBrowser: false,
      },
    },
    {
      path: '/mall/share',
      name: 'mall_share',
      component: MallShare,
      meta: {
        title: '分享',
        keepAlive: false,
        logined: false,
        notBrowser: false,
      },
    },
    {
      path: '/online/school',
      name: 'online_school',
      component: OnlineSchool,
      meta: {
        title: '校区',
        keepAlive: false,
        logined: false,
        notBrowser: false,
      },
    },
    {
      path: '/online/select/student',
      name: 'online_select_student',
      component: OnlineSelectStudent,
      meta: {
        title: '挑选学员',
        keepAlive: false,
        logined: false,
        notBrowser: false,
      },
    },
    {
      path: '/online/product/list',
      name: 'online_product_list',
      component: OnlineProductList,
      meta: {
        keepAlive: false,
        logined: false,
        notBrowser: false,
      },
    },
    {
      path: '/online/product/detail',
      name: 'online_product_detail',
      component: OnlineProductDetail,
      meta: {
        title: '商品详情',
        keepAlive: false,
        logined: false,
        notBrowser: false,
      },
    },
    {
      path: '/online/order/confirm',
      name: 'online_Order_confirm',
      component: OnlineOrderConfirm,
      meta: {
        title: '确认订单',
        keepAlive: false,
        logined: false,
        notBrowser: false,
      },
    },
    {
      path: '/online/order/detail',
      name: 'online_order_detail',
      component: OnlineOrderDetail,
      meta: {
        title: '订单详情',
        keepAlive: false,
        logined: false,
        notBrowser: false,
      },
    },
    {
      path: '/online/add/student',
      name: 'online_add_student',
      component: OnlineAddStudent,
      meta: {
        title: '添加学员',
        keepAlive: false,
        logined: false,
        notBrowser: false,
      },
    },
    {
      path: '/online/relevance',
      name: 'online_relevance',
      component: OnlineRelevance,
      meta: {
        title: '添加关联学员',
        keepAlive: false,
        logined: false,
        notBrowser: false,
      },
    },
    {
      path: '/online/pay/success',
      name: 'online_pay_success',
      component: OnlinePaySuccess,
      meta: {
        title: '支付成功',
        keepAlive: false,
        logined: false,
        notBrowser: false,
      },
    },
    {
      path: '/mall/browser_warning',
      name: 'browser_warning',
      component: () => import('@/module/mall/BrowserWarning.vue'),
      meta: {
        title: '在线商城',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/online/recommend',
      name: 'online_recommend',
      component: OnlineRecommend,
      meta: {
        title: '推荐',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/online/search',
      name: 'online_search',
      component: OnlineSearch,
      meta: {
        title: '搜索',
        keepAlive: false,
        logined: false,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/Mall.js